export function findAncestor(elem: HTMLElement, selector: string) {
  let parent: HTMLElement | null = elem;

  while (parent) {
    if (parent.matches && parent.matches(selector)) {
      return parent;
    }

    parent = parent.parentNode ? (parent.parentNode as HTMLElement) : null;
  }

  return null;
}

export default findAncestor;
